module.exports = __webpack_public_path__ + "img/20.133acb2.jpg";